
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116.49 72","width":"58","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#e74816","d":"M74 64.3H42.49V7.7H74v56.6z"}}),_c('path',{attrs:{"d":"M44.5 36A35.91 35.91 0 0158.25 7.7a36 36 0 100 56.6A35.91 35.91 0 0144.5 36z","fill":"#db001b"}}),_c('path',{attrs:{"d":"M115.37 58.31v-1.4H115l-.42 1-.42-1h-.36v1.4h.25v-1.06l.4.91h.27l.39-.91v1.06zm-2.31 0v-1.16h.46v-.24h-1.19v.24h.47v1.16zM116.49 36a36 36 0 01-58.24 28.3 36 36 0 000-56.6A36 36 0 01116.49 36z","fill":"#ef8b06"}})])
          )
        }
      }
    